import { ActionReducer, MetaReducer } from '@ngrx/store';
import { AppState } from './app.state';

export function localStorageSyncReducer(
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> {
  return (state, action) => {
    const nextState = reducer(state, action);

    const keysToPersist: (keyof AppState)[] = ['auth', 'layout', 'paginationFilter']; // puedo agregar mas estados a rehidratar --> [ 'auth', 'layout' ]

    keysToPersist.forEach((key) => {
      const subState = nextState[key];
      if (subState !== undefined) {
        localStorage.setItem(key, JSON.stringify(subState));
      }
    });

    return nextState;
  };
}

export function rehydrateState(): Partial<AppState> {
  const rehydratedState: Partial<AppState> = {};

  const keysToRehydrate: (keyof AppState)[] = ['auth', 'layout', 'paginationFilter']; // puedo agregar mas estados a rehidratar --> [ 'auth', 'layout' ]

  keysToRehydrate.forEach((key) => {
    const storedValue = localStorage.getItem(key);
    if (storedValue) {
      rehydratedState[key] = JSON.parse(storedValue);
    }
  });

  return rehydratedState;
}

export const metaReducers: MetaReducer<AppState>[] = [localStorageSyncReducer];
